import type { Ref } from 'vue';
import type { FeaturePrototype } from '@puppycad/cad-core';
import type { ExtrudeViewportRef } from '../extrude-types';

/**
 * 同步正式提交后的结果体。
 *
 * @param input 同步上下文。
 */
export async function syncCommittedBlendFeatureResult(input: {
  /** 视口适配器。 */
  viewportRef: ExtrudeViewportRef;
  /** 上游实体对象 ID。 */
  upstreamBodyObjectId: Ref<string | null>;
  /** 提交结果。 */
  result: {
    replaced: boolean;
    prototype: FeaturePrototype;
    meshData: unknown | null;
    objectId?: string;
  };
}): Promise<void> {
  if (input.result.replaced) {
    return;
  }

  if (input.result.meshData && input.viewportRef.value?.addMesh) {
    await input.viewportRef.value.addMesh(input.result.meshData, {
      prototype: input.result.prototype,
    });
    if (
      input.upstreamBodyObjectId.value
      && input.result.objectId
      && input.upstreamBodyObjectId.value !== input.result.objectId
    ) {
      input.viewportRef.value.removeMesh(input.upstreamBodyObjectId.value);
    }
    return;
  }

  await input.viewportRef.value?.syncFeatureMeshes?.({
    preservePreviewMeshes: true,
  });
}
